export const applicationsData = [
  {
    id: 'text-analyze',
    name: '文本分析',
    description: '导入日语文本，获得汉字注音、词汇等级标注、朗读音频。',
    imageUrl: '/assets/img/app1.png',
  },
];
